import { jsx as _jsx } from "react/jsx-runtime";
import { LocalizationProvider as LocalizationProviderMUI } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
export const DayjsDateTimeLocalizationProvider = (props) => {
    return _jsx(LocalizationProviderMUI, Object.assign({ dateAdapter: AdapterDayjs }, props));
};
